import { isDefined } from '@sgme/fp';
import { useContext } from 'react';

import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import {
  callOrderContext,
  useCallOrderTileId,
  useValidateCallOrder,
} from '@/App/tiles/orders/CallOrder/CallOrderCreationTile/CallOrderContext.tsx';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput';
import { OmsFieldErrorWrapper } from '@/components/ui/OmsFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectCallOrderErrors, selectLimitPriceCallOrder } from '@/store/orders/call/selectors.ts';
import { useDebounce } from '@/utils/hooks/debounce.ts';

export const CallOrderLimitPrice = () => {
  const tileId = useCallOrderTileId();
  const setIsModifyingField = useContext(callOrderContext).setIsModifyingField;
  const track = useTrackEvent();

  const value = useAppSelector((state) => selectLimitPriceCallOrder(state, tileId));
  const errors = useAppSelector((state) => selectCallOrderErrors(state, tileId));

  const validateCallOrder = useValidateCallOrder();

  const handleLimitPriceChange = useDebounce((newValue: number | undefined) => {
    track('Order action', 'Limit price changed');
    validateCallOrder({
      limitPrice: newValue,
    });
  });

  const limitPriceError = errors?.limitPrice;

  return (
    <OrderRow labelId="order.fields.limitPrice.label">
      <OmsFieldErrorWrapper errors={limitPriceError}>
        <SgNumberInput
          valuePosition="start"
          value={value}
          maxDecimals={9}
          onFocus={() => setIsModifyingField(true)}
          onBlur={() => setIsModifyingField(false)}
          onChange={handleLimitPriceChange}
          size="sm"
          data-e2e="limit-price"
          selectAllOnFocus
          state={isDefined(limitPriceError) ? 'invalid' : undefined}
        />
      </OmsFieldErrorWrapper>
    </OrderRow>
  );
};
